import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { maxDateValidator } from '@mynexus/mynexus-ui-lib';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    templateUrl: './date-time-modal.component.html',
    styleUrls: ['./date-time-modal.component.scss'],
    standalone: false
})
export class DateTimeModalComponent {
  maxDate = new Date();

  dateForm = new FormGroup({
    'dateTimeFaxReceived': new FormControl(null, [Validators.required, maxDateValidator])
  });

  constructor(public ref: DynamicDialogRef) { }

  onClose() {
    this.ref.close(this.dateForm.controls['dateTimeFaxReceived'].value);
  }
}
